import React, { useState, useEffect } from 'react'
import RuleCreateBatchTable from './RuleCreateBatchTable'
import { getListBatchRule, listPartner, getListCategory } from '../../../services/api/3dApi'
import { Link } from 'react-router-dom'
import { Pagination, Select, Spin, message, Input, TimePicker } from 'antd'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import SearchGroup from '../../shared/SearchGroup'
import queryString from 'query-string'
import UseDebounce from '../../users/helpers/UseDebounce'
import { size_of_raw_materials, daysOfWeek } from '../constant/config'
import moment from 'moment'

function RuleCreateBatchPage() {
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [listRule, setListRule] = useState([])
    const [tags, setTags] = useState('')
    const [stores, setStores] = useState('')
    const [listParner, setListPartner] = useState([])
    const [type, setType] = useState([])
    const [loading, setLoading] = useState(false)
    const [partner, setPartner] = useState([])
    const [status, setStatus] = useState('true')
    const [ruleType, setRuleType] = useState([])
    const [priority, setPriority] = useState('')
    const [isSelectedAll, setIsSelectedAll] = useState(false)
    const [selectedItems, setSelectedItems] = useState([])

    const [weekday, setWeekday] = useState([])
    const [timeRange, setTimeRange] = useState({})
    const [categories, setCategories] = useState([])
    const [category, setCategorie] = useState([])

    const debouncePriority = priority ? UseDebounce(priority, 500) : UseDebounce(priority, 0)

    const onChangeTimeSchedule = (field, value) => {
        if (field === 'end' && !value) {
            setTimeRange({})
        } else {
            setTimeRange(pre => ({
                ...pre,
                [field]: value
            }))
        }
    }

    const fetchListRule = async () => {
        setLoading(true)
        setIsSelectedAll(false)
        setSelectedItems([])
        setError('')
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            const schedule = {}
            if (!!weekday && weekday.length > 0) schedule.days_of_week = weekday
            if (!!timeRange && Object.keys(timeRange).length > 0) {
                const { start = '', end = '' } = { ...timeRange }
                if (!!start) schedule.start = moment(start).format("HH:mm")
                if (!!end) schedule.end = moment(end).format("HH:mm")
            }

            if (type.length) payload.sku = type
            if (tags) payload.tags = tags
            if (stores) payload.store = stores
            if (priority) payload.priority = priority
            if (partner) payload.partner = partner
            if (status !== '') payload.status = status
            if (ruleType) payload.is_fit = ruleType
            if (!!category && category.length > 0) payload.catalog = category
            if (Object.keys(schedule).length > 0) payload.schedule = schedule

            const { data: res } = await getListBatchRule(payload)
            const { data, success, error: mess } = { ...res }

            if (success) {
                setListRule(data.rules)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const getListPartner = async () => {
        const payload = {
            limit: 10000,
            page: 1,
            hidden: false,
        }
        try {
            const query = queryString.stringify(payload)
            const { data: Data } = await listPartner(query)
            const { data, success, message } = Data
            if (success) {
                setListPartner(data.partners)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchListCategory = async () => {
        const payload = {
            limit: 10000,
            page: 1,
        }

        try {
            const { data: Data } = await getListCategory(payload)
            const { data: res, success, message } = Data
            if (success) {
                const { data } = res
                setCategories(data)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeGroupSearch = (e) => {
        const { store, tag, priority } = e
        setTags(tag)
        setStores(store)
        setPriority(priority)
        setPage(1)
    }

    const handleChangePartner = (value) => {
        setPartner(value)
        setPage(1)
    }

    const handleChangeCategory = (value) => {
        setCategorie(value)
        setPage(1)
    }

    const handleChangeStatus = (value) => {
        setStatus(value)
        setPage(1)
    }

    const handleChangeRuleType = (value) => {
        setRuleType(value)
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const handleChangeInput = (e) => {
        setPriority(e.target.value)
    }

    useEffect(() => {
        fetchListRule()
    }, [type, limit, page, tags, stores, partner, status, ruleType, debouncePriority, weekday, timeRange, category])

    useEffect(() => {
        getListPartner()
        fetchListCategory()
    }, [])

    const toggleSelectAll = (isChecked) => {
        if (isChecked) {
            const itemIds = listRule.map(item => item._id)
            setSelectedItems(itemIds)
            setIsSelectedAll(true)
        } else {
            setSelectedItems([])
            setIsSelectedAll(false)
        }
    }

    const updateSelectedItems = (id, value) => {
        if (value && !selectedItems.includes(id)) {
            setSelectedItems([...selectedItems, id])
            setIsSelectedAll(selectedItems.length + 1 === listRule.length)
        } else {
            const filtered = selectedItems.filter(itemId => itemId !== id)
            setSelectedItems(filtered)
            setIsSelectedAll(false)
        }
    }

    const { Option } = Select

    const optionPartner = listParner.filter(i => i.name === 'QUANG MINH' || i.name === 'BINH MINH' || i.name === 'TOÀN CẦU')

    return (
        <div className='RuleCreateBatchPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách quy tắc tạo lô</h3>
                        <div className='d-flex align-items-center'>
                            <Link
                                className='ant-btn btn-success ant-btn-primary ml-3'
                                to='create-rule'
                                disabled={loading}
                            >
                                Tạo Rule
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4 mb-3'>
                                <label className='font-weight-bold d-block'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                    disabled={loading}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Search:</label>
                                <SearchGroup
                                    options={
                                        [
                                            { title: 'Tag', key: 'tag', value: tags },
                                            { title: 'Store', key: 'store', value: stores },
                                            // { title: 'Priority', key: 'priority', value: priority },
                                        ]
                                    }
                                    onSearch={handleChangeGroupSearch}
                                    search={tags}
                                    disabled={loading}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Partner:</label>
                                <Select
                                    name='partner'
                                    className='partner'
                                    onChange={(value) => handleChangePartner(value)}
                                    value={partner}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn partner'
                                    style={{ width: '100%' }}
                                    disabled={loading}
                                >
                                    {!!optionPartner.length && optionPartner.map((i, index) => (
                                        <Option key={i._id} value={i._id}>{i.name}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Status:</label>
                                <Select
                                    name='status'
                                    className='status'
                                    onChange={(value) => handleChangeStatus(value)}
                                    value={status}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn status'
                                    style={{ width: '100%' }}
                                    disabled={loading}
                                >
                                    <Option value={''}>All</Option>
                                    <Option value={'true'}>Active</Option>
                                    <Option value={'false'}>Deactive</Option>
                                </Select>
                            </div>
                            <div className='col-12 col-xl-1 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Loại rule:</label>
                                <Select
                                    name='status'
                                    className='status'
                                    onChange={(value) => handleChangeRuleType(value)}
                                    value={ruleType || []}
                                    allowClear
                                    showArrow
                                    placeholder='Loại rule'
                                    style={{ width: '100%' }}
                                    disabled={loading}
                                >
                                    <Option value={'n'}>Số lượng</Option>
                                    <Option value={'y'}>Diện tích</Option>
                                </Select>
                            </div>
                            <div className='col-12 col-xl-4 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Schedule:</label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Select
                                        placeholder="Thứ"
                                        style={{ width: 250 }}
                                        onChange={(value) => setWeekday(value)}
                                        allowClear
                                        mode="multiple"
                                        showSearch
                                        value={weekday || []}
                                    >
                                        {daysOfWeek.map((day) => (
                                            <Option key={day.value} value={day.value}>
                                                {day.label}
                                            </Option>
                                        ))}
                                    </Select>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <TimePicker
                                            value={timeRange.start}
                                            onChange={(value, timeString) => onChangeTimeSchedule('start', value)}
                                            format="HH:mm"
                                            placeholder="Bắt đầu"
                                            className='start-custom'
                                        />
                                        <TimePicker
                                            value={timeRange.end}
                                            onChange={(value, timeString) => onChangeTimeSchedule('end', value)}
                                            format="HH:mm"
                                            placeholder="Kết thúc"
                                            className='end-custom'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Priority:</label>
                                <Input.Search
                                    placeholder='Type to search Priority...'
                                    className='Priority'
                                    allowClear
                                    value={priority || ''}
                                    onChange={handleChangeInput}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Danh mục sản phẩm:</label>
                                <Select
                                    name='category'
                                    className='category'
                                    onChange={(value) => handleChangeCategory(value)}
                                    value={category}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn danh mục'
                                    style={{ width: '100%' }}
                                    disabled={loading}
                                    mode='multiple'
                                    showSearch
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {!!categories.length && categories.map((i, index) => (
                                        <Option key={i._id} value={i._id}>{i.name}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                            {/* <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Khổ NVL:</label>
                                <Select
                                    name='category'
                                    className='category'
                                    // onChange={(value) => handleChangeCategory(value)}
                                    value={category}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn danh mục'
                                    style={{ width: '100%' }}
                                    disabled={loading}
                                >
                                    {size_of_raw_materials.map((i, index) => (
                                        <Option key={i.label} value={i.label}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div> */}
                        </div>

                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} rules`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <RuleCreateBatchTable
                            listRule={listRule}
                            selectedItems={selectedItems}
                            isSelectedAll={isSelectedAll}
                            setType={setType}
                            setTags={setTags}
                            setPage={setPage}
                            setStores={setStores}
                            reset={fetchListRule}
                            toggleSelectAll={toggleSelectAll}
                            updateSelectedItems={updateSelectedItems}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default RuleCreateBatchPage